import clsx from "clsx";

interface SlideProps {
    clients: string[];
    direction?: "left" | "right";
}

const Slide: React.FC<SlideProps> = ({ clients, direction = "left" }) => {
    const loopedClients = [...clients, ...clients];
    const animationSpeedPerCard = 3;
    const duration = clients.length * animationSpeedPerCard;

    return (
        <div
            className={clsx("scroll-track", { right: direction === "right" })}
            style={{ animationDuration: `${duration}s` }}
        >
            {loopedClients.map((client, idx) => (
                <div key={`${client}-${idx}`} className="scroll-card">
                    <img
                        src={`/assets/clients/${client}.png`}
                        alt={`Client ${client}`}
                        width={215}
                        height={81}
                        loading="lazy"
                        decoding="async"
                        style={{ height: "auto", maxWidth: "215px", width: "100%" }}
                    />
                </div>
            ))}
        </div>
    );
};

export { Slide };
